import { toast } from 'react-toastify';

import Toast from '../components/toast';

export default (content, type, options = { toastId: content?.title ?? content }) => {
  const methodType = (type) ? toast[type] : toast;
  const data = typeof content === 'string' ? { title: content } : content;
  
  methodType(Toast, { data, ...options });
};
